import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
import { UserRole } from "@faire/web-api--source/indigofair/data/UserRole";

import { getGlobalProperty } from "./globals/getGlobalProperty";

export const isBrandPreview = (): boolean => {
  if (getGlobalProperty("editingAsBrandToken")) {
    return true;
  }
  const userRoles = getUser()?.roles ?? [];
  const allowedRoles = [UserRole.MAKER, UserRole.MAKER_EDITOR];

  return intersection(allowedRoles, userRoles).length > 0;
};

const getUser = (): IUser | undefined => getGlobalProperty("user");

const intersection = <T>(array1: T[], array2: T[]): T[] =>
  array1.filter((allowedRole) => array2.includes(allowedRole));
